import { Emitter } from '@epihub/core/src/events';
import { type ActionEvent } from '@krishanmadan/core/src/model/actions';

export const actionEvent = Emitter.event<{
  visitorId: string;
  data: ActionEvent;
}>('action')((data) => ({
  visitorId: data.visitorId,
}));
